import { set } from './local';

export const local = {
    set,
};
